import { render, staticRenderFns } from "./TopContestant.vue?vue&type=template&id=2c5f5b04&scoped=true&"
import script from "./TopContestant.vue?vue&type=script&lang=js&"
export * from "./TopContestant.vue?vue&type=script&lang=js&"
import style0 from "./TopContestant.vue?vue&type=style&index=0&id=2c5f5b04&prod&lang=css&"
import style1 from "./TopContestant.vue?vue&type=style&index=1&id=2c5f5b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f5b04",
  null
  
)

export default component.exports